import Button from 'component/atom/forms/button/Button';
import Header from 'component/layout/header/Header';
import NewUserForm from 'component/organism/new-user/NewUserForm';
import { usePost } from 'hooks/usePost';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import styles from './NewUser.module.scss';

const NewUser = () => {
  const { id } = useParams();
  const formRef = useRef();

  const { mutate: AddUser, isPending: isAdding } = usePost();
  const { mutate: EditUser, isPending: isUpdating } = usePost();
  return (
    <>
      <Header
        isBack
        title={id ? 'Update Profile' : 'Create New User'}
        children={
          <Button
            label={`${id ? 'Update Profile' : 'Save'}`}
            type='save'
            inputType='submit'
            onClick={() => formRef.current?.handleSubmit()}
            isLoading={isAdding || isUpdating}
            className={styles.updateBtn}
          />
        }
      />
      <NewUserForm
        id={id}
        formRef={formRef}
        AddUser={AddUser}
        EditUser={EditUser}
      />
    </>
  );
};

export default NewUser;
